import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Multiple app-custom-select instances can sit side by side (e.g. the header's
 * Academic Year + Department filters). Each instance owns its own open/closed
 * state, so without coordination two can end up open — and their popovers
 * overlapping — at once. Every instance opening itself broadcasts its id here
 * so siblings can close.
 */
@Injectable({ providedIn: 'root' })
export class CustomSelectCoordinatorService {
  private opened = new Subject<symbol>();
  opened$ = this.opened.asObservable();

  notifyOpen(id: symbol): void {
    this.opened.next(id);
  }
}
